import { LitElement, html, svg } from 'lit';

export class IconUsers16 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16"><title>To personer</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M5.5 7a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5ZM11.5 7.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM1.001 13.905a4.5 4.5 0 0 1 8.999 0M14.958 14v-.318a3.684 3.684 0 0 0-4.06-3.663"></path></svg>`; }
}
if (!customElements.get('f-icon-users16', IconUsers16)) {
  customElements.define('f-icon-users16', IconUsers16);
}